import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: localStorage.getItem("isLoggedIn")
    ? JSON.parse(localStorage.getItem("isLoggedIn"))
    : false,
  userInfo: null,
  token: localStorage.getItem("jwt") && localStorage.getItem("jwt") !== "undefined"
    ? JSON.parse(localStorage.getItem("jwt"))
    : null,
    isModalVisible: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("jwt", JSON.stringify(action.payload));
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
      state.isLoggedIn = true;
      localStorage.setItem("isLoggedIn", true);
      // localStorage.setItem("userInfo", JSON.stringify(action.payload));
    },
    showModal: (state) => {
      state.isModalVisible = true;
    },
    hideModal: (state) => {
      state.isModalVisible = false;
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
      state.token = null;
      state.isLoggedIn = false;
      const otp = localStorage.getItem('appvalue');
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("jwt");
      localStorage.removeItem("companyData");
      localStorage.removeItem("industryData");
      localStorage.removeItem("userSelectedCompany");
      localStorage.removeItem("authorizedSignatory");
      localStorage.removeItem("companyAddress");
      localStorage.removeItem("userindividualID");
      localStorage.removeItem("invite_code");
      localStorage.clear();
      if (otp) {
        localStorage.setItem('appvalue', otp);
      }
    },
  },
});

export const { setUserInfo, clearUserInfo, setToken, showModal, hideModal } = authSlice.actions;

export default authSlice.reducer;
